import { render } from "./TuitionFeeFilter.vue?vue&type=template&id=36bca050&ts=true"
import script from "./TuitionFeeFilter.ts?vue&type=script&lang=ts&external"
export * from "./TuitionFeeFilter.ts?vue&type=script&lang=ts&external"

import "./TuitionFeeFilter.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__